var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('md-toolbar',[_c('div',{staticClass:"container d-flex"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/246x0w.png","alt":"Logo"}})]),_c('h3',{staticClass:"md-title ml-4"},[_vm._v(" KMPUS Placement Test ")])])]),_c('router-view',{staticClass:"container main-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }